/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.MerchantAccounts {
  angular.module("meevo.plugins.merchantAccounts", []);
}